module.exports = __webpack_public_path__ + "img/big_magic.a03041f0.jpg";